import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  catchErrorAndEvict,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers';

import { LANGUAGE_LIST } from '../../../graphql';
import { LanguageListModel } from '../../../models';

@Injectable({ providedIn: 'root' })
export class LanguageListService {
  private readonly apollo = inject(Apollo);

  private clientName = APOLLO_CLIENT_NAMES.contact;

  getLanguagesList(): Observable<LanguageListModel> {
    const fieldName =
      getQueryRootFieldName(LANGUAGE_LIST) || 'getAllLanguagesList';

    return this.apollo
      .use(this.clientName)
      .query({
        query: LANGUAGE_LIST,
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result.data.getAllLanguagesList),
        catchErrorAndEvict(this.apollo, this.clientName, fieldName),
      );
  }
}
